// 🔧 store_builder.js
// ✅ Purpose: Orchestrates Event Merch Store demo data creation
// ✅ Features:
// - Generates store products and variants
// - Seeds store data through repository layer
// - Updates DemoContext with store results
// - Returns standardized Demo Report results
// - Fully block-commented for clarity and future devs

import { generateStore } from "./store_generator";
import { seedStore } from "./store_seeder";
import { buildStoreReport } from "./store_report";

export const buildStore = async ({ demoContext } = {}) => {
  console.log("🛒 Store Builder started.");

  const storePlan = generateStore({ demoContext });

  const storeResults = await seedStore({
    demoContext,
    storePlan,
  });

  demoContext.store = {
    products: storeResults.products || [],
    variants: storeResults.variants || [],
  };

  return buildStoreReport({ storeResults });
};